<template>
  <div class="aw-match-op">
    <div class="com-sub-top">
      <div class="title container-center">赛事运营</div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">核心能力</p>
        <p class="desc" style="margin-bottom: 24px">
          连续执行承办了全国大学生集成电路创新创业大赛全国总决赛，并作为全国大学生集成电路创新创业大赛芯片应用赛道FPGA应用开发赛“海云捷迅”杯杯赛企业；中国机器人及人工智能大赛“智能产线应用场景赛”赛道技术支持企业；中国国际“互联网+”大学生创新创业大赛FPGA方向唯一命题企业等。参与到各类国家级学科竞赛的组织、命题、评审及举办工作。
        </p>
        <p class="desc">
          以国家级学科大赛为重要锚点，结合其他学科类、生态企业类的沟通交流活动，推动英特尔FPGA中国创新中心的产教融合协同发展，致力于打造集“政、产、学、研、用”于一体的集成电路产业生态体系，促进跨领域深度融合和合作，推动重庆区域集成电路行业发展，激活新的产业势能。打通了地方政府、高校院所及行业企业之间的沟通桥梁，构建了一个集成电路产业的“命运共同体”。
        </p>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">运营案例</p>
        <p class="small-title">大赛运营及命名</p>
        <div class="com-tab-box unio-style">
          <div class="p-box container-center">
            <p :class="{ active: key == '1' }" @click="choose('1')">
              全国大学生集成电路创新创业<br />大赛
            </p>
            <p :class="{ active: key == '2' }" @click="choose('2')">
              中国机器人及人工智能大赛
            </p>
            <p :class="{ active: key == '3' }" @click="choose('3')">
              中国大学生服务外包创新创业<br />大赛
            </p>
            <p :class="{ active: key == '4' }" @click="choose('4')">
              中国国际“互联网+”大学生<br />创新创业大赛
            </p>
            <p :class="{ active: key == '5' }" @click="choose('5')">
              FPGA智能创新国际大赛
            </p>
          </div>

        </div>
        <div class="tab-content">
            <div v-if="key == '1'">
                <p class="tab-title">最大规模最高档次全国赛事</p>
                <p class="tab-desc">国内集成电路领域最大规模高校赛事，中国高等教育学会全国高校竞赛榜单唯一入榜集成电路专业赛事</p>
                <ul class="tab-list">
                    <li>
                        <img src="@/assets/match/match_icon_1_1@2x.png" alt="">
                        <p class="li-title">企业杯赛，覆盖全产业链</p>
                        <p class="li-desc">数十家行业重要企业冠名出题，赛题方向覆盖全产业链关键环节</p>
                    </li>
                    <li>
                        <img src="@/assets/match/match_icon_1_2@2x.png" alt="">
                        <p class="li-title">三大赛项，面向多层次人才</p>
                        <p class="li-desc">主赛项，职业技能赛项，创新创业成果赛项，面向本硕博，中高职不同层次人才</p>
                    </li>
                    <li>
                        <img src="@/assets/match/match_icon_1_3@2x.png" alt="">
                        <p class="li-title">产学合作，全方位生态服务</p>
                        <p class="li-desc">人才招聘、成果转化、协同育人，赛事服务平台助力产学全方位合作</p>
                    </li>
                    <li>
                        <img src="@/assets/match/match_icon_1_4@2x.png" alt="">
                        <p class="li-title">百万奖金</p>
                        <p class="li-desc">总奖金额超过一百万元，多个专项奖励</p>
                    </li>
                </ul>
                <p class="tab-desc">海云捷迅于2021年起，连续三年冠名该赛事全国总决赛，并负责该赛事全国总决赛的执行承办工作。连续4年举办该赛事“海云捷迅”杯的比赛。</p>
                <img class="match-img1" src="@/assets/match/match_img_1_1@2x.png" alt="">
            </div>

            <div v-if="key == '2'">
                <p class="single-desc">第二十五届中国机器人及人工智能大赛贵州省赛支持单位</p>
                <img class="match-img2" src="@/assets/match/match_img_1_2@2x.png" alt="">
                <p class="single-desc">第二十六届中国机器人及人工智能大赛智能产业应用场景赛承办单位</p>
                <div class="match-img-box">
                    <img src="@/assets/match/match_img_1_3@2x.png" alt="">
                    <img src="@/assets/match/match_img_1_4@2x.png" alt="">
                </div>
                
            </div>

            <div v-if="key == '3'" class="service-match-box">
                <div>
                    <p>第十二届中国大学生服务外包创新创业大赛，A20赛题：<span>基于FPGA的车牌识别应用设计</span>。由我司命题，使用了人工智能边缘实验平台作为赛题的实现硬件，共计支撑了80余只参赛团队的比赛。</p>
                    <p>第十三届中国大学生服务外包创新创业大赛，我司设立命题：赛题编号A08，<span>基于FPGA的铝片表面工业缺陷检测系统</span>。</p>
                </div>
                <img class="match-img3" src="@/assets/match/match_img_1_5@2x.png" alt="">
            </div>

            <div v-if="key == '4'">
                <p class="single-desc" style="text-align: center;margin:0">重庆海云捷迅命题方向</p>
                <img class="match-img4" src="@/assets/match/match_img_1_6@2x.png" alt="">
            </div>

            <div v-if="key == '5'">
                <img class="match-img5" src="@/assets/match/match_img_1_7@2x.png" alt="">
            </div>
        </div>

        <p class="small-title" style="margin-top: 80px">全球性高峰论坛运营</p>
        <div class="com-tab-box">
          <div class="p-box container-center">
            <p :class="{ active: subKey == '1' }" @click="subChoose('1')">
              FPGA智能创新国际峰会
            </p>
            <p :class="{ active: subKey == '2' }" @click="subChoose('2')">
              全国集成电路产教融合高峰论坛
            </p>
          </div>
        </div>
        
        <div class="tab-content">
            <div v-if="subKey == '1'">
                <img class="match-img6" src="@/assets/match/match_img_2_1@2x.png" alt="">
            </div>

            <div v-if="subKey == '2'">
                <img class="match-img7" src="@/assets/match/match_img_2_2@2x.png" alt="">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      key: "1",
      subKey: "1"
    };
  },
  methods: {
    choose(val) {
      this.key = val;
    },
    subChoose(val) {
      this.subKey = val;
    },
  },
};
</script>